import { formatBytes } from '@lib/utils/units'

import type { AttachmentItem, StorageLimits } from '@/types/models'

export const increaseStorageLimits = (
  state: StorageLimits,
  items: AttachmentItem[]
): StorageLimits => {
  const usage = items.reduce<number>(
    (result, item) => result + item.size,
    state.usage
  )

  const hUsage = formatBytes(usage)
  const percentageUsage =
    state.max === 0 ? 0 : Math.round((100 * usage) / state.max)

  return {
    ...state,

    usage,
    hUsage,
    percentageUsage,
  }
}

export const decreaseStorageLimits = (
  state: StorageLimits,
  items: AttachmentItem[]
): StorageLimits => {
  const usage = items.reduce<number>(
    (result, item) => result - item.size,
    state.usage
  )

  const hUsage = formatBytes(usage)
  const percentageUsage = Math.round((100 * usage) / state.max)

  return {
    ...state,

    usage,
    hUsage,
    percentageUsage,
  }
}
